export const FETCH_FORM_1_SUBMIT = 'untrust.form1.submit.fetching',
  FETCH_FORM_1_SUBMIT_SUCCESS = 'untrust.form1.submit.success',
  FETCH_FORM_1_SUBMIT_ERROR = 'untrust.form1.submit.failed',
  
  FETCH_FORM_2_SUBMIT = 'untrust.form2.submit.fetching',
  FETCH_FORM_2_SUBMIT_SUCCESS = 'untrust.form2.submit.success',
  FETCH_FORM_2_SUBMIT_ERROR = 'untrust.form2.submit.failed';



// WEBPACK FOOTER //
// ./src/views/untrust/_types.js